import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withGenericConfig } from "contexts/generic-config-context";
import { StyledSolutionsSubmenuComponent } from "./solutions-submenu-component.scss";
import { SOLUTIONS_SECTIONS } from "./solutions-submenu-constants";
const SolutionsSubmenuComponent = ({ translate })=>{
    return /*#__PURE__*/ _jsx(StyledSolutionsSubmenuComponent, {
        className: "solutions-submenu-component",
        children: SOLUTIONS_SECTIONS.map(({ groupKey, items })=>/*#__PURE__*/ _jsxs("div", {
                className: "solutions-section submenu-stagger-item",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "section-header submenu-stagger-item",
                        children: translate(groupKey)
                    }),
                    items.map(({ labelKey, link, variant, Icon })=>/*#__PURE__*/ _jsxs("a", {
                            className: variant === "icon" ? "icon-item submenu-stagger-item" : "text-item submenu-stagger-item",
                            href: link,
                            rel: "noreferrer",
                            children: [
                                Icon && /*#__PURE__*/ _jsx("span", {
                                    className: "item-icon",
                                    children: /*#__PURE__*/ _jsx(Icon, {})
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: `item-label${variant === "icon" ? " item-label--product" : ""}`,
                                    children: translate(labelKey)
                                })
                            ]
                        }, link))
                ]
            }, groupKey))
    });
};
export default withGenericConfig(SolutionsSubmenuComponent);
